import { useState } from "react";

export const useAppModal = () => {
  const [modalMode, setModalMode] = useState(null); // 'add' | 'edit'
  const [editAppData, setEditAppData] = useState(null);

  const handleEditApp = (app) => {
    return () => {
      setEditAppData(app);
      setModalMode("edit");
    };
  };

  const handleOpenAdd = () => {
    setEditAppData(null);
    setModalMode("add");
  };

  const handleCloseModal = () => {
    setModalMode(null);
    setEditAppData(null);
  };

  return {
    modalMode,
    editAppData,
    handleEditApp,
    handleOpenAdd,
    handleCloseModal,
  };
};
